import cast from 'utils/cast';

export default function(actions, findType, findTarget) {
  return actions.findIndex(({ type, target }) => (
    type === findType
    && target.type === findTarget.type
    && cast(target.id, 'string') === cast(findTarget.id, 'string')
  ));
}
